import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax

import '@/assets/scss/main.scss'

import '@/assets/css/main.css'

import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

require('@/assets/css/iconfont.css')

import {themeConfig} from '@/constants/config'

import Vue from 'vue'

import Vuesax from 'vuesax'
import {colors} from '@/constants/config'
Vue.use(Vuesax, { theme:{ colors }, rtl: themeConfig.rtl })

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')

import {VueHammer} from 'vue2-hammer'
Vue.use(VueHammer)

import VueThailandAddress from 'vue-thailand-address';
Vue.use(VueThailandAddress)
require('vue-thailand-address/dist/vue-thailand-address.css')
